import React from "react";
import { Route, Link } from "react-router-dom";
import baseImage from "../../../../assets/images/content-for-photography.jpg";
import questionIcon from "../../../../assets/images/icons/MA-Question-Icon";


export default class VirtualSuiteTypeItem extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    let virtual_suite_type = this.props.virtual_suite_type;
    let id = "";
    let textId = "";
    let imageId = "";
    let virtualClassName = "virtual-staging-modal-category-container"

    if (this.props.selected) {
      id = "virtualStagingCategorySelected"
      textId = "categoryItemTextSelected"
      imageId = "categoryItemImageSelected"
    }

    if (this.props.homepage){
      virtualClassName = "virtual-staging-modal-category-container virtual-staging-modal-category-container-homepage"
    }

    return (
      <div onClick={() => this.props.toggleSelected(virtual_suite_type)} id={id} className={virtualClassName}>
        <img id={imageId} className="categoryItemImage"src={virtual_suite_type.cover}></img>
        <div className="categoryItemDescriptionDiv">
          <div className="categoryItemText" id={textId}>{virtual_suite_type.name}</div>
          <div className="toolTip"><img className="categoryQuestionIcon" src={questionIcon} /></div>
            {virtual_suite_type.description ? <span className="categoryDescription">{virtual_suite_type.description}</span> : ""}
        </div>
      </div>
    )
  }
}